const EXP_API_URI = '/account/api/client/experience/v2/load';
export const PROFILE_ID_TYPE = 'RETAIL_PROFILE_ID_TYPE';
export const nonProdLogoutKey = process.env.NEXT_PUBLIC_LOGOUT_API_KEY_NON_PROD;
export const prodLogoutKey = process.env.NEXT_PUBLIC_LOGOUT_API_KEY_PROD;
export const i90ProdApiKey = process.env.NEXT_PUBLIC_I90_API_KEY_PROD;
export const i90NonProdApiKey = process.env.NEXT_PUBLIC_I90_API_KEY_NON_PROD;
export const EXP_API_V2 = '/api/client/experience/v2/load';

export const XROUTEHDR = {
  gke: 'PHARMACY-GKE',
  rke: 'PHARMACY-RKE',
  gkeAndRke: 'account-gke-rke'
};

export const apiAttributes = [
  {
    envName: 'PROD',
    urlPrefix: 'https://www.cvs.com',
    apiHeader: undefined,
    ice: {
      apiKey: process.env.NEXT_PUBLIC_ICE_API_KEY_PROD
    }
  },
  {
    envName: 'CSR',
    urlPrefix: 'https://www-csr.cvs.com',
    apiHeader: undefined,
    ice: {
      apiKey: process.env.NEXT_PUBLIC_ICE_API_KEY_PROD
    },
    addAndAuthorizeCaregivee: {
      url: EXP_API_URI,
      apikey: process.env.NEXT_PUBLIC_I90_API_KEY_PROD,
      experienceId: 'c9c9cd9b-3f1e-41fd-bf2c-7ba014bc7b18',
      clientId: 'cvs_account'
    }
  },
  {
    envName: 'QA1',
    urlPrefix: 'https://www-qa1.cvs.com',
    apiHeader: 'QA1',
    ice: {
      apiKey: process.env.NEXT_PUBLIC_ICE_API_KEY_NON_PROD
    }
  },
  {
    envName: 'QA2',
    urlPrefix: 'https://www-qa2.cvs.com',
    apiHeader: 'QA2',
    ice: {
      apiKey: process.env.NEXT_PUBLIC_ICE_API_KEY_NON_PROD
    }
  },
  {
    envName: 'QA2-CSR',
    urlPrefix: 'https://www-qa-csr.cvs.com',
    apiHeader: 'QA2',
    ice: {
      apiKey: process.env.NEXT_PUBLIC_ICE_API_KEY_NON_PROD
    },
    addAndAuthorizeCaregivee: {
      url: EXP_API_URI,
      apikey: process.env.NEXT_PUBLIC_I90_API_KEY_NON_PROD,
      experienceId: 'c9c9cd9b-3f1e-41fd-bf2c-7ba014bc7b18',
      clientId: '1744955'
    }
  },
  {
    envName: 'LOCAL',
    urlPrefix: 'https://www-qa2.cvs.com',
    apiHeader: 'QA2',
    ice: {
      apiKey: process.env.NEXT_PUBLIC_ICE_API_KEY_NON_PROD
    },
    addAndAuthorizeCaregivee: {
      url: EXP_API_URI,
      apikey: process.env.NEXT_PUBLIC_I90_API_KEY_NON_PROD,
      experienceId: 'c9c9cd9b-3f1e-41fd-bf2c-7ba014bc7b18',
      clientId: '1744955'
    }
  }
];

export const APIROUTEPREFIX = '/account-lookup';
